<script lang="ts" setup>
import type { CategoryPageBanners } from '~/types/Catalog';

const props = defineProps<{ banners: CategoryPageBanners }>();
const { isMobile } = useBreakpoints();

function handleBannerClick() {
  const processBanner = async (banner: any) => {
    if (banner.link_type === 'modal') {
      openModal(banner.iframe);
    } else if (banner.link_type === 'link') {
      await navigateTo(banner.link, {
        external: true,
        open: { target: banner.target as string },
      });
    }
  };

  if (isMobile.value && props.banners.mobile) {
    processBanner(props.banners.mobile);
  } else if (!isMobile.value && props.banners.desktop) {
    processBanner(props.banners.desktop);
  }
}

const isShowModal = ref(false);
const currentIframe = ref<string | null>(null);

function openModal(iframe?: string) {
  if (!iframe) return;

  isShowModal.value = true;
  currentIframe.value = iframe;
}

function closeModal() {
  isShowModal.value = false;
  currentIframe.value = null;
}
</script>

<template>
  <button
    class="category-page-banners"
    @click="handleBannerClick"
  >
    <picture
      v-if="banners.mobile"
      class="block md:hidden"
    >
      <source
        :srcset="`${banners.mobile.images.conversions_webp.thumb_390} 1x, ${banners.mobile.images.conversions_webp.thumb_780} 2x`"
        type="image/webp"
      />
      <source
        :srcset="banners.mobile.images.conversions.thumb_390"
        type="image/jpeg"
      />
      <img
        :src="banners.desktop.images.url"
        alt="category banner"
      />
    </picture>

    <picture
      v-if="banners.desktop"
      class="hidden md:block"
    >
      <source
        :srcset="`${banners.desktop.images.conversions_webp.thumb_1400} 1x, ${banners.desktop.images.conversions_webp.thumb_2800} 2x`"
        type="image/webp"
      />
      <source
        :srcset="banners.desktop.images.conversions.thumb_1400"
        type="image/jpeg"
      />
      <img
        :src="banners.desktop.images.url"
        alt="category banner"
      />
    </picture>

    <CleanModal
      v-model="isShowModal"
      @close="closeModal"
    >
      <div
        class="frame-for-iframe"
        v-html="currentIframe"
      />
    </CleanModal>
  </button>
</template>

<style lang="scss">
.category-page-banners {
  overflow: hidden;
  border-radius: 12px;

  @include screen-md {
    border-radius: 16px;
  }

  & img {
    width: 100%;
    height: auto;
  }
}

.frame-for-iframe {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 800px;
  height: 744px;
  border-radius: 24px;

  & iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
